module.exports = __webpack_public_path__ + "media/assets/images/integromat-logo-3f852fde0209f34432921df6882cea79.png";